import {Component} from '@angular/core';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'ngx-chart-bar-optimizer',
    templateUrl: './optimizer-bar-chart.component.html',
    styleUrls: ['./optimizer-bar-chart.component.scss'],
})
export class OptimizerBarChartComponent {}
